import { Controller } from "@hotwired/stimulus"

// The domains most of our visitors use. A typed domain one or two keystrokes away from one
// of them ("gmial.com", "hotmail.con") is almost always that one, and an address that
// never arrives loses the diagnostic's results for good.
const DOMAINS = [
  "gmail.com", "hotmail.com", "outlook.com", "yahoo.com", "icloud.com", "live.com",
  "yahoo.com.mx", "hotmail.es", "outlook.es", "live.com.mx", "prodigy.net.mx"
]
const MAX_DISTANCE = 2

// Offers the correction and leaves the choice to the visitor: a domain we do not know may
// be exactly right (a university, a hospital), so nothing is changed unasked.
export default class extends Controller {
  static targets = ["input", "hint", "suggestion"]

  check() {
    const suggestion = suggest(this.inputTarget.value)
    if (!suggestion) return this.clear()

    this.suggestionTarget.textContent = suggestion
    this.hintTarget.hidden = false
  }

  accept() {
    this.inputTarget.value = this.suggestionTarget.textContent
    this.clear()
    this.inputTarget.focus()
  }

  clear() {
    this.hintTarget.hidden = true
  }
}

function suggest(address) {
  const at = address.lastIndexOf("@")
  if (at < 1) return null

  const domain = address.slice(at + 1).trim().toLowerCase()
  if (!domain || DOMAINS.includes(domain)) return null

  let best = null
  let bestDistance = MAX_DISTANCE + 1
  for (const candidate of DOMAINS) {
    const distance = levenshtein(domain, candidate)
    if (distance < bestDistance) {
      best = candidate
      bestDistance = distance
    }
  }
  return best ? `${address.slice(0, at)}@${best}` : null
}

function levenshtein(a, b) {
  let previous = Array.from({ length: b.length + 1 }, (_, index) => index)
  for (let i = 1; i <= a.length; i++) {
    const current = [i]
    for (let j = 1; j <= b.length; j++) {
      current[j] = Math.min(
        previous[j] + 1,
        current[j - 1] + 1,
        previous[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)
      )
    }
    previous = current
  }
  return previous[b.length]
}
